import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "pages",
  "use": "pages-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pages\"><path d=\"M11.667 1.667H5a1.667 1.667 0 00-1.667 1.667v13.333A1.667 1.667 0 005 18.334h10a1.667 1.667 0 001.667-1.667v-10l-5-5z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M11.666 1.667v5h5M13.333 10.833H6.666M13.333 14.167H6.666M8.333 7.5H6.667\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/pages.svg
// module id = blPW
// module chunks = 38 43